/*
* 商家管理
* */

import { get, post,postJson,postUrl } from './axios'

// const RESOURCE_BASE_PATH = 'http://116.196.113.156/jd-yusms/seller'
const RESOURCE_BASE_PATH = '/seller'

export const getGiveSmsCount = p => get(`/home/getGiveSmsCount`, p);

//  获取客户信息
export const getSellerInfo = p => get(`${RESOURCE_BASE_PATH}/current`, p);

//获取当前登陆用户信息
export const getSellerPlatform = p => get(`/seller/current`, p);

//获取当前登陆用户信息
export const getCheckCode = p => get(`/tbPhoneBinding/checkCode`, p);

//修改平台版账号手机号接口
export const updatePlatformAccountMobile = p => postJson(`/tbPhoneBinding/updatePlatformAccountMobile`, p);

// 短信转移获取当前的总条数
export const getShopInfo = p => get(`${RESOURCE_BASE_PATH}/getShopInfo`, p);

// 切换店铺
export const switchShop = p => postUrl(`${RESOURCE_BASE_PATH}/switchShop`, p);

// 更新商家单价
export const updateUnitPrice = (p1, p2) => get(`${RESOURCE_BASE_PATH}/updateUnitPrice/${p1}/${p2}`);

// 返回旧系统
export const returnOldSystem = p => get(`${RESOURCE_BASE_PATH}/returnOldSystem`);

// 内容解密
export const decrypt = p => get(`${RESOURCE_BASE_PATH}/content/decrypt`,p);

// 手机号解密
export const decryptPhone = p => get(`${RESOURCE_BASE_PATH}/default/content/decrypt`,p);

// 获取用户菜单列表
export const getMenuList = p => get(`${RESOURCE_BASE_PATH}/menus`,p);

// 获取用户菜单列表
export const getSeller = p => get(`/seller/current`, p);


// 生效弹窗列表
export const validPopups = p => get(`/popup/validPopups`, p);


// 弹窗弹出记录
export const displayRecord = p => postJson(`/popup/displayRecord/${p}`);

// 获取顶栏图
export const homeController = p => get(`/home/topBar`, p);

// 导出数据
export const officialExport = p => get(`/sms/marketing/effect/analyze/official/export?${p}`);

// 设置默认店铺
export const setDefault = p => post(`${RESOURCE_BASE_PATH}/yunzhou/set-default`, p)

/**
 * 跳转至咚咚
 * @param {*} p 
 * @returns 
 */
export const getJumpDD = ({ dongUserAccountName, jumpType}) => get(`/seller/getDongLoinTokenUrl?userAccountName=${dongUserAccountName}&jumpType=${jumpType}`);

// 切换旧版
export const back2CRM = p => get(`/login/back2CRM`, p);

// 获取云起BI信息
export const getYunzhouBiInfo = p => get(`/seller/getYunzhouBiInfo`);
